import { PricesResponseV2 } from "@ssc-booking/api-contracts"
import * as F from "fp-ts/function"
import * as ROA from "fp-ts/ReadonlyArray"
import * as SP from "fp-ts/Separated"
import { availablePrices } from "../../_common/price-response"

export class SuiteCategoryValidator {
    private suiteCategories: readonly string[] = []

    pricesLoaded(prices: PricesResponseV2["prices"]): SuiteCategoryValidator {
        this.suiteCategories = F.pipe(
            availablePrices(prices),
            ROA.map(({ suiteCategory }) => suiteCategory),
        )
        return this
    }

    isValid(suiteCategory: string) {
        return this.suiteCategories.includes(suiteCategory)
    }
}
